/* global G */
/* eslint-disable no-unused-vars */
import find from 'lib/sequence/component/children/find'
import { asyncPipeSpread } from 'lib/util'

/**
 * Displays the description as the step's title if defined.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const setStepState = module => async (components, ...args) => {
  const { description: model } = module[G.MODEL][G.CHILDREN]

  const { component } = components
  const stepState = component[G.STATE]

  if (model[G.CACHE]?.text) {
    stepState.title = `${model[G.CACHE].text.substring(0, 40)}...`
  }

  return [components, ...args]
}

/**
 * Issue step.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => await asyncPipeSpread(
  setStepState(module),
)(find(component), ...args)
